module.exports = __webpack_public_path__ + "static/lights35-053a1412d25db54d3ecad89ef6001e4a.jpg";